export const getErrorCodeShowWhiteList = (action, code) => {
    const whiteList = {
      DATAFLOW_BUILDER_LIST_DATAFLOW_PRODUCTION_FLAG_SET : ["DATABROWSER_NOT_CONFIGURED", "DATABROWSER_NOT_FOUND", "DATABROWSER_FORBIDDEN", "DATABROWSER_ERROR"],
      DATAFLOW_BUILDER_LIST_DATAFLOW_MAPPING_SET_UNSET : ["DATABROWSER_NOT_CONFIGURED", "DATABROWSER_NOT_FOUND", "DATABROWSER_FORBIDDEN", "DATABROWSER_ERROR"],
    }
    if (action in whiteList) {
      return whiteList[action].indexOf(code) !== -1 ? true : false;
    } else {
      return false;
    }
};